import type { InstructorLesson } from '../types';

// Prochain événement daté du moniteur (J28, 28/10/2026) : sa prochaine leçon ou son prochain accompagnement à
// l'examen, montré dans « Ma journée » quand il n'a plus de leçon à venir aujourd'hui. Règle pure : les leçons
// (planning) et les accompagnements sont lus par l'appelant.

/** Accompagnement à l'examen tel que le rend `/v1/exams/accompaniments/me`. */
export interface Accompaniment {
  id: string;
  candidate_name: string;
  center: string;
  timezone: string;
  starts_at: string;
  ends_at: string;
}

export type NextEvent =
  | { kind: 'lesson'; startsAt: string; endsAt: string; lesson: InstructorLesson }
  | { kind: 'exam'; startsAt: string; endsAt: string; accompaniment: Accompaniment };

/** Semaines de planning parcourues pour trouver la prochaine leçon (et jours d'accompagnements lus). */
export const NEXT_EVENT_WEEKS = 4;

/** Leçon à venir (ni créneau à réserver, ni annulée), la plus proche. */
export function nextLesson(lessons: InstructorLesson[], now: number): NextEvent | null {
  const lesson = lessons
    .filter((l) => !l.isOpenSlot && l.status !== 'cancelled' && Date.parse(l.startsAt) > now)
    .sort((a, b) => Date.parse(a.startsAt) - Date.parse(b.startsAt))[0];
  return lesson ? { kind: 'lesson', startsAt: lesson.startsAt, endsAt: lesson.endsAt, lesson } : null;
}

/** Accompagnement à venir, le plus proche. */
export function nextAccompaniment(accompaniments: Accompaniment[], now: number): NextEvent | null {
  const accompaniment = accompaniments
    .filter((a) => Date.parse(a.starts_at) > now)
    .sort((a, b) => Date.parse(a.starts_at) - Date.parse(b.starts_at))[0];
  return accompaniment ? { kind: 'exam', startsAt: accompaniment.starts_at, endsAt: accompaniment.ends_at, accompaniment } : null;
}

/** Le plus proche des deux ; à la même heure, la leçon. */
export function earliest(...events: Array<NextEvent | null>): NextEvent | null {
  return events.reduce<NextEvent | null>(
    (best, event) => (event && (!best || Date.parse(event.startsAt) < Date.parse(best.startsAt)) ? event : best),
    null,
  );
}
